export default __webpack_public_path__ + "static/media/2488754-ai.ac616db3.png";